var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rb-video-ribbon px-5 py-3"},[_vm._v("\n\tPróximo vídeo em "+_vm._s(_vm.secondsLeft.pad(2))+"s\n")])}
var staticRenderFns = []

export { render, staticRenderFns }